const localization = {
  closeLabel: 'Close drawer',
}

export default localization
